var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllergy2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.155,
    height: 73.156,
    viewBox: "0 0 69.155 73.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34352",
    "data-name": "Group 34352",
    transform: "translate(-172.546 -447.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32466",
    "data-name": "Group 32466",
    transform: "translate(174.296 449.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32460",
    "data-name": "Group 32460",
    transform: "translate(26.611 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26564",
    "data-name": "Path 26564",
    d: "M6590.23,2826.521c0-3.755-2.783-6.8-6.216-6.8s-6.216,3.043-6.216,6.8,2.783,8.765,6.216,8.765S6590.23,2830.275,6590.23,2826.521Z",
    transform: "translate(-6577.798 -2819.723)",
    fill: "none",
    stroke: "#7acfd1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    y1: 20.194,
    transform: "translate(32.827 49.216)",
    fill: "none",
    stroke: "#7acfd1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26565",
    "data-name": "Path 26565",
    d: "M6526.388,2871.609l-21.713,4.962a2.729,2.729,0,0,0-2.161,2.58v.028h0a3.15,3.15,0,0,0,2.822,3.134l17.218-2.249a3.126,3.126,0,0,1,3.124,3l.185,2.59",
    transform: "translate(-6502.513 -2853.269)",
    fill: "none",
    stroke: "#7acfd1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26566",
    "data-name": "Path 26566",
    d: "M6586.833,2956.333l-.039,1.827a5.743,5.743,0,0,1-5.742,5.62h-4.9a5.744,5.744,0,0,1-5.74-5.521l-.912-23.46",
    transform: "translate(-6545.823 -2894.124)",
    fill: "none",
    stroke: "#7acfd1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26567",
    "data-name": "Path 26567",
    d: "M6619.831,2871.609l21.712,4.962a2.729,2.729,0,0,1,2.162,2.58v.028h0a3.151,3.151,0,0,1-2.823,3.134l-17.218-2.249a3.127,3.127,0,0,0-3.124,3l-1.193,24.681",
    transform: "translate(-6578.05 -2853.269)",
    fill: "none",
    stroke: "#7acfd1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26568",
    "data-name": "Path 26568",
    d: "M6595.385,3016.089",
    transform: "translate(-6562.557 -2946.679)",
    fill: "none",
    stroke: "#7acfd1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_506",
    "data-name": "Ellipse 506",
    cx: 3.871,
    cy: 3.871,
    r: 3.871,
    transform: "translate(37.304 54.473)",
    fill: "none",
    stroke: "#7acfd1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 3.85,
    cy: 3.85,
    r: 3.85,
    transform: "translate(19.499 32.474)",
    fill: "none",
    stroke: "#7acfd1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergy2);
export default __webpack_public_path__ + "static/media/allergy-2.c078073a732e4468f4eb362b455cf652.svg";
export { ForwardRef as ReactComponent };